import { render, staticRenderFns } from "./Axis.vue?vue&type=template&id=05b26631&scoped=true&"
import script from "./Axis.vue?vue&type=script&lang=js&"
export * from "./Axis.vue?vue&type=script&lang=js&"
import style0 from "./Axis.vue?vue&type=style&index=0&id=05b26631&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b26631",
  null
  
)

export default component.exports